module.exports = __webpack_public_path__ + "img/WhatsAppButtonGreenSmall.9e07c341.svg";